<!-- 商品管理 V2 方案 - 贩售方案单条编辑（下单链接 / 注意事项 / OPTION / 标签） -->
<template>
  <div class="plan-editor">
    <!-- 方案名称与操作 -->
    <div class="plan-name-row">
      <label>方案名称：</label>
      <el-input v-model="plan.name" maxlength="20" show-word-limit />
      <div class="plan-save-actions">
        <el-button @click="$emit('save')">保存</el-button>
        <!-- 默认下单方案直接绑定接口字段 is_default，由父页面负责取消其他方案的默认状态。 -->
        <el-checkbox
          v-model="plan.is_default"
          :true-label="1"
          :false-label="0"
          @change="$emit('set-default', $event)"
        >默认下单</el-checkbox>
      </div>
        <el-button class="red-button" @click="$emit('copy')">复制一条</el-button>
        <el-button class="dark-button" @click="$emit('delete')">删除</el-button>
    </div>

    <!-- 下单链接：主商品 + 组合商品 + 绑定辅料 -->
    <div class="subsection order-link-section">
      <h3>下单链接</h3>
      <div class="native-table link-table">
        <div class="table-head link-grid">
          <div>商品链接</div>
          <div>商品图片</div>
          <div>商品属性</div>
          <div>进货价</div>
          <div>配套数量</div>
          <div>操作</div>
        </div>
        <div class="link-group">
          <div class="table-row link-grid main-product-row">
            <div class="link-cell">
              <div class="product-row-head"><span class="main-product-tag">主商品</span><el-button class="red-button latest-link-button" @click="useLatestLink">使用最新下单链接</el-button></div>
              <el-input v-model="plan.link" type="textarea" :rows="3" resize="none" @blur="fetchMainProduct" />
              <p>请使用1688或taobao或RAKUMART的商品链接，其他平台商品链接暂时不支持下单。</p>
            </div>
            <div><el-image v-if="plan.pic" class="table-product-image" :src="plan.pic" fit="cover" :preview-src-list="[plan.pic]" /></div>
            <div class="attribute-list" @click="editMainAttribute">
              <p v-for="(sku, skuIndex) in plan.detail" :key="skuIndex">{{ sku.key }}：{{ sku.value }}</p>
              <span v-if="!plan.detail.length" class="attribute-empty">点击选择</span>
            </div>
            <div class="price-cell">{{ plan.price }}</div>
            <div><el-input v-model="plan.num" class="quantity-input" /></div>
            <div class="row-actions">
              <el-button class="green-button" @click="openBindMaterial">绑定辅料使用</el-button>
              <el-button class="red-button" @click="addProduct">添加组合商品</el-button>
            </div>
          </div>

          <div v-if="plan.material.length" class="material-strip">
            <div v-for="(material, materialIndex) in plan.material" :key="material.material_id || materialIndex" class="material-card">
              <img v-if="material.main_image" :src="material.main_image" alt="">
              <div class="material-info">
                <div class="material-name">{{ material.name }}</div>
                <p>库存数量：{{ material.material_stock_num }}</p>
                <label>消耗：<el-input v-model="material.consume" size="mini" /> 点/套</label>
              </div>
              <button type="button" @click="plan.material.splice(materialIndex, 1)"><i class="el-icon-close"></i></button>
            </div>
          </div>

          <div v-for="(product, childIndex) in plan.children" :key="product.id || childIndex" class="table-row link-grid child-product-row">
            <div class="link-cell">
              <span class="child-product-tag"><i class="el-icon-link"></i> 组合物{{ childIndex + 1 }}</span>
              <el-input v-model="product.link" type="textarea" :rows="2" resize="none" @blur="fetchChildProduct(childIndex)" />
              <p>请使用1688或taobao或RAKUMART的商品链接，其他平台商品链接暂时不支持下单。</p>
            </div>
            <div><el-image v-if="product.pic" class="table-product-image" :src="product.pic" fit="cover" :preview-src-list="[product.pic]" /></div>
            <div class="attribute-list" @click="editChildAttribute(childIndex)">
              <p v-for="(sku, skuIndex) in product.detail" :key="skuIndex">{{ sku.key }}：{{ sku.value }}</p>
              <span v-if="!product.detail.length" class="attribute-empty">点击选择</span>
            </div>
            <div class="price-cell">{{ product.price }}</div>
            <div><el-input v-model="product.num" class="quantity-input" /></div>
            <div class="child-actions"><span>下单时同步下单：</span><el-checkbox v-model="product.auto_order" :true-label="1" :false-label="0">使用</el-checkbox><button type="button" @click="plan.children.splice(childIndex, 1)">删除</button></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 注意事项：备注与采购/检品/配货要求 -->
    <div class="notice-card">
      <h3>注意事项管理</h3>
      <div class="notice-grid">
        <div v-for="item in noticeItems" :key="item.key" class="notice-item">
          <strong>{{ item.label }}</strong>
          <div class="notice-follow"><span>下单跟随到订单：</span><el-checkbox v-model="notice[item.key].use" :true-label="1" :false-label="0">使用</el-checkbox></div>
          <el-input v-model="notice[item.key].text" type="textarea"  resize="none" />
        </div>
      </div>
    </div>

    <option-settings :options="plan.option" :user-id="detail.user_id" />

    <tag-settings :tags="plan.order_detail_tag" :detail="detail" />

    <bind-material-dialog ref="bindMaterialDialog" @confirm="onMaterialConfirm" />
    <!-- 商品属性选择（网站 SKU / 人工编辑） -->
    <el-dialog title="商品属性编辑" :visible.sync="attributeDialogVisible" width="900px" append-to-body :close-on-click-modal="false">
      <edit-attribute :key="attributeEditorKey" ref="attributeEditor" @save="receiveAttributeEdit" />
      <span slot="footer">
        <el-button @click="attributeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="$refs.attributeEditor.save()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import EditAttribute from '@/components/common/editAttribute.vue'
import BindMaterialDialog from './planEditor/bindMaterialDialog'
import OptionSettings from './planEditor/optionSettings'
import TagSettings from './planEditor/tagSettings'

const CHILD_MAX = 3 // 组合商品最多 3 个

/**
 * 贩售方案编辑器
 * 负责链接解析、属性选择、辅料/OPTION/标签及注意事项
 */
export default {
  name: 'PlanEditor',
  components: { EditAttribute, BindMaterialDialog, OptionSettings, TagSettings },
  props: {
    plan: { type: Object, required: true },
    detail: { type: Object, required: true },
    saving: { type: Boolean, default: false }
  },
  data() {
    return {
      attributeDialogVisible: false, // 属性弹窗
      attributeEditorKey: 0, // 每次打开属性编辑器都重新挂载，避免复用上一次的选择状态
      attributeEditTarget: 'main', // main 或组合商品下标
      goodsInventory: [], // 当前编辑目标的 SKU 库存（用于回填价格）
      // 解析链接后的商品详情缓存，key 为 main 或组合商品下标
      productParticularsCache: {}
    }
  },
  computed: {
    notice() {
      return this.plan.notice || this.detail.notice
    },
    noticeItems() {
      return [
        { key: 'remark', label: '客户商品管理备注' },
        { key: 'y_remark', label: '业务备注' },
        { key: 'purchase_notice', label: '采购调查要求' },
        { key: 'inspect_notice', label: '检品要求' },
        { key: 'delivery_notice', label: '配货要求' }
      ]
    }
  },
  methods: {
    getProductCacheKey(targetIndex) {
      return targetIndex === 'main' ? 'main' : String(targetIndex)
    },
    // 缓存 goodsParticulars 响应，供属性弹窗使用
    setProductParticulars(targetIndex, productRes) {
      const product = productRes.data || {}
      const goodsInfo = product.goodsInfo || {}
      this.$set(this.productParticularsCache, this.getProductCacheKey(targetIndex), {
        particularsRes: productRes,
        goodsInventory: goodsInfo.goodsInventory || []
      })
    },
    getProductParticulars(targetIndex) {
      return this.productParticularsCache[this.getProductCacheKey(targetIndex)]
    },
    addProduct() {
      // 追加一条组合商品行
      if (this.plan.children.length >= CHILD_MAX) {
        this.$message.warning('组合商品最多添加3个')
        return
      }
      this.plan.children.push({
        name: '',
        link: '',
        from_platform: '',
        goods_id: '',
        goods_title: '',
        price: '',
        num: 1,
        pic: '',
        detail: [],
        sku_id: '',
        spec_id: '',
        shop_id: '',
        shop_name: '',
        option: [],
        client_remark: '',
        auto_order: 1
      })
    },
    // 解析商品链接：goodsUrlToGoodsId + goodsParticulars
    fetchProductByUrl(url, targetIndex, options = {}) {
      const { assign, preserveDetail = false } = options
      const link = (url || '').trim()
      if (!link) return Promise.resolve(false)
      return this.$api.goodsUrlToGoodsId({ goods_url: link }).then(res => {
        const timestamp = Math.floor(Date.now() / 1000)
        const sign = 'wakanda forever!@9523`'
        return this.$api.orderApi.goodsParticulars({
          shop_type: res.data.from_platform,
          goods_id: res.data.goods_id,
          mi_id: res.data.mi_id,
          timestamp,
          sign: this.$md5(`${sign}${timestamp}${sign}`)
        }).then(productRes => {
          const product = productRes.data
          this.setProductParticulars(targetIndex, productRes)
          if (assign) {
            const updates = {
              goods_id: product.goodsId,
              goods_title: product.titleC,
              shop_id: product.shopId,
              shop_name: product.shopName,
              from_platform: product.fromPlatform,
              pic: product.images[0]
            }
            if (!preserveDetail) {
              Object.assign(updates, {
                detail: [],
                price: '',
                sku_id: '',
                spec_id: ''
              })
            }
            assign(updates)
          }
          return true
        })
      }).catch(() => false)
    },
    // 主商品链接失焦解析
    fetchMainProduct() {
      return this.fetchProductByUrl(this.plan.link, 'main', {
        assign: data => {
          Object.assign(this.plan, data)
        }
      }).then(success => {
        if (success) this.editMainAttribute()
      })
    },
    // 组合商品链接失焦解析
    fetchChildProduct(index) {
      const child = this.plan.children[index]
      return this.fetchProductByUrl(child.link, index, {
        assign: data => {
          Object.assign(child, data)
          child.name = data.goods_title
        }
      }).then(success => {
        if (success) this.editChildAttribute(index)
      })
    },
    // 填入该商品最新下单链接并解析
    useLatestLink() {
      this.$api.productManagementApi.getLatestLink({
        user_id: this.detail.user_id,
        sys_code: this.detail.sys_code
      }).then(res => {
        if (res.data.link) {
          this.plan.link = res.data.link
          this.fetchMainProduct()
        }
      })
    },
    editMainAttribute() {
      this.openAttributeEditor('main', this.plan)
    },
    editChildAttribute(index) {
      this.openAttributeEditor(index, this.plan.children[index])
    },
    // 无缓存时若链接非空会重新解析后再打开
    openAttributeEditor(targetIndex, target) {
      const showEditor = () => {
        const cache = this.getProductParticulars(targetIndex)
        if (!cache || !cache.particularsRes) return
        this.attributeEditTarget = targetIndex
        this.goodsInventory = cache.goodsInventory
        this.attributeEditorKey += 1
        this.attributeDialogVisible = true
        this.$nextTick(() => {
          this.$refs.attributeEditor.goodsParticulars(JSON.parse(JSON.stringify(cache.particularsRes)), {
            detail: target.detail,
            sorting: targetIndex === 'main' ? 1 : targetIndex + 2,
            from_platform: target.from_platform,
            type: 'detail'
          })
        })
      }

      const cache = this.getProductParticulars(targetIndex)
      if (cache && cache.particularsRes) {
        showEditor()
        return
      }

      const link = (target.link || '').trim()
      if (!link) {
        this.$message.warning('请先输入商品链接')
        return
      }

      this.fetchProductByUrl(link, targetIndex, {
        assign: data => Object.assign(target, data),
        preserveDetail: true
      }).then(success => {
        if (success) {
          showEditor()
          return
        }
        this.$message.warning('商品链接解析失败，请检查后重试')
      })
    },
    // 属性保存：回填 detail / 价格 / sku_id / spec_id
    receiveAttributeEdit(list, pic) {
      const target = this.attributeEditTarget === 'main' ? this.plan : this.plan.children[this.attributeEditTarget]
      target.detail = list
        .filter(item => String(item.key || '').trim() && String(item.value || '').trim())
        .map(item => ({ key: item.key, value: item.value }))
      if (pic) target.pic = pic
      const skuValue = target.detail.map(item => item.value).join('㊖㊎')
      const inventory = this.goodsInventory.find(item => item.keyC === skuValue)
      if (inventory) {
        target.price = inventory.valueC[0].price
        target.sku_id = inventory.valueC[0].skuId
        target.spec_id = inventory.valueC[0].specId
        target.num = 1
      }
      this.attributeDialogVisible = false
    },
    openBindMaterial() {
      this.$refs.bindMaterialDialog.open(this.detail.user_id)
    },
    // 绑定辅料到当前方案 material 列表
    onMaterialConfirm(list) {
      list.forEach(item => {
        if (!this.plan.material.some(material => material.material_id === item.material_id)) {
          this.plan.material.push({ ...item, name: item.name_trans })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.plan-editor { margin-top: 24px; }
.plan-name-row { display: grid; grid-template-columns: auto 460px 1fr auto auto; align-items: center; gap: 12px; height: 40px; }
.plan-name-row .el-button { margin: 0; }
.plan-save-actions { display: flex; align-items: center; gap: 16px; }
.blue-button { border-color: #2c96e7 !important; background: #2c96e7 !important; color: #fff !important; }
.green-button { border-color: #15ad3c !important; background: #15ad3c !important; color: #fff !important; }
.red-button { border-color: #b4272d !important; background: #b4272d !important; color: #fff !important; }
.dark-button { border-color: #333 !important; background: #333 !important; color: #fff !important; }
h3 { margin: 0; font-size: 16px; line-height: 22px; }
.subsection,
.notice-card,
.tag-card { margin-top: 24px; padding: 24px; border-radius: 8px; background: #fff; }
.subsection > h3 { margin-bottom: 24px; }
.native-table { width: 100%; overflow: hidden; }
.table-head { min-height: 54px; background: #edeff4; }
.table-row { min-height: 112px; border-bottom: 1px solid #dcdfe6; background: #fff; }
.table-head,
.table-row { display: grid; }
.table-head > div,
.table-row > div { box-sizing: border-box; display: flex; align-items: center; justify-content: center; min-width: 0; padding: 10px; }
.link-table { overflow: visible; }
.link-table .table-head { margin-bottom: 4px; }
.link-grid { grid-template-columns: 25fr 16fr 25fr 10fr 8fr 16fr; }
.link-group { overflow: hidden; border: 1px solid #f0a33a; border-radius: 4px; }
.link-group .table-row:last-child { border-bottom: 0; }
.main-product-row,
.child-product-row { min-height: 112px; border-color: #f2dfc2; }
.main-product-row { background: #fff4e2; }
.child-product-row { background: #fff9f0; }
.link-cell { flex-direction: column; align-items: stretch !important; }
.product-row-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.main-product-tag,
.child-product-tag { align-self: flex-start; color: #e49a2e; font-size: 12px; line-height: 20px; }
.main-product-tag { padding: 1px 7px; border-radius: 2px; background: #efa633; color: #fff; }
.child-product-tag { margin-bottom: 7px; }
.latest-link-button { height: 28px; padding: 0 11px; font-size: 12px; }
.link-cell p { margin: 6px 0 0; color: #e05a61; font-size: 11px; line-height: 16px; }
::v-deep .link-cell .el-textarea__inner { min-height: 48px !important; padding: 7px 9px; font-size: 12px; line-height: 16px; }
.table-product-image { width: 68px; height: 68px; border-radius: 3px; }
.attribute-list { display: block !important; cursor: pointer; }
.attribute-list p { margin: 3px 0; line-height: 18px; }
.attribute-empty { color: #999; }
.attribute-edit { display: flex; align-items: center; margin: 4px 0; }
.attribute-edit .el-input { width: 112px; }
::v-deep .attribute-edit .el-input__inner { height: 30px; padding: 0 7px; }
.price-cell { color: #333; font-variant-numeric: tabular-nums; }
.quantity-input { width: 96px; }
.row-actions { flex-wrap: wrap; gap: 8px; }
.row-actions .el-button { margin: 0; }
.row-actions button:not(.el-button),
.option-grid button { border: 0; background: none; color: #b4272d; cursor: pointer; }
.child-actions { gap: 6px; color: #555; font-size: 12px; white-space: nowrap; }
.child-actions button { margin-left: 10px; border: 0; background: none; color: #b4272d; cursor: pointer; }
.material-strip { display: flex; flex-wrap: wrap; gap: 14px; min-height: 92px; padding: 12px 20px; border-bottom: 1px solid #f2dfc2; background: #fff; box-sizing: border-box; }
.material-card { position: relative; box-sizing: border-box; display: flex; align-items: center; width: 210px; min-height: 68px; padding: 10px 26px 10px 10px; border: 1px solid #dcdfe6; border-radius: 5px; background: #fff; }
.material-card img { flex: 0 0 48px; width: 48px; height: 48px; margin-right: 10px; border-radius: 3px; object-fit: cover; }
.material-info { display: flex; flex: 1; flex-direction: column; min-width: 0; font-size: 12px; line-height: 18px; }
.material-name { overflow: hidden; font-size: 12px; text-overflow: ellipsis; white-space: nowrap; }
.material-info p { margin: 2px 0; color: #666; font-size: 12px; }
.material-info label { display: flex; align-items: center; margin-top: 5px; color: #666; white-space: nowrap; }
.material-info label .el-input { width: 54px; margin: 0 4px; }
.material-card > button { position: absolute; top: -7px; right: -7px; width: 20px; height: 20px; padding: 0; border: 0; border-radius: 50%; background: #b4272d; color: #fff; cursor: pointer; }
.notice-card { padding: 20px; }
.notice-card > h3 { margin-bottom: 20px; font-size: 16px; font-weight: 700; }
.notice-grid { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: 20px; }
.notice-item { min-width: 0; }
.notice-item > strong { display: block; margin-bottom: 12px; line-height: 20px; }
.notice-follow { display: flex; align-items: center; min-height: 20px; margin-bottom: 10px; color: #666; font-size: 12px; }
.notice-follow span { white-space: nowrap; }
.notice-follow .el-checkbox { margin-left: 4px; }
::v-deep .notice-follow .el-checkbox__label { padding-left: 5px; color: #666; font-size: 12px; }
::v-deep .notice-item .el-textarea__inner { height: 220px; padding: 9px 10px; line-height: 18px; }
.notice-source { display: block; margin: 5px 0 3px; color: #888; font-size: 12px; }
::v-deep .notice-item .el-textarea + .notice-source { margin-top: 8px; }
.section-toolbar { display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px; }
.option-grid { grid-template-columns: 4fr 1fr 1fr 100px; }
.option-table .table-row { min-height: 72px; }
.option-grid .el-radio { display: block; margin: 5px 0; }
.media-list { display: grid !important; grid-template-columns: repeat(3, 50px); gap: 12px; }
.media-list img,
.media-list video { display: block; width: 50px; height: 50px; border-radius: 4px; object-fit: cover; }
.small-file-list { display: block !important; }
.small-file-list a { display: block; overflow: hidden; color: #0d4fe6; text-overflow: ellipsis; white-space: nowrap; }
.tag-row-detail { display: grid; grid-template-columns: 240px 1fr; gap: 30px; padding: 24px 0; border-top: 1px solid #dcdfe6; }
.tag-preview { display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 160px; border: 1px solid #dcdfe6; }
.tag-preview span { margin-top: 20px; font-size: 18px; }
.tag-fields { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; }
.tag-fields label { color: #666; }
.tag-fields .el-input { margin-top: 6px; }
::v-deep .el-input__inner,
::v-deep .el-textarea__inner { border-color: #dcdfe6; border-radius: 4px; color: #333; }
::v-deep .el-textarea__inner { font-family: inherit; }
</style>
